import { useRouteError } from 'react-router-dom'
import { AlertOctagon } from 'lucide-react'
import { Button, EmptyState } from '@/components/ui'
import { useT } from '@/internationalization/i18n'

/**
 * Route-level error boundary.
 *
 * It shows the real error message: this is an internal tool for a technical
 * audience, and hiding the message behind "something went wrong" costs a
 * support round trip on every occurrence. Reload is a full reload, not a
 * router navigation — the app state is what failed.
 */
export function ErrorPage() {
  const t = useT()
  const error = useRouteError()
  const message = error instanceof Error ? error.message : String(error ?? t('error.unknown'))

  return (
    <div className="flex min-h-dvh items-center justify-center bg-canvas p-6">
      <div className="w-full max-w-lg">
        <EmptyState
          icon={<AlertOctagon />}
          title={t('error.title')}
          description={t('error.body')}
          action={
            <Button variant="primary" onClick={() => window.location.reload()}>
              {t('error.reload')}
            </Button>
          }
        />
        <pre className="mt-4 overflow-x-auto rounded-md border border-border bg-surface-muted p-3 text-xs text-fg-muted">
          {message}
        </pre>
      </div>
    </div>
  )
}
